import { render, staticRenderFns } from "./PreQuestion2.vue?vue&type=template&id=8906e37c&scoped=true&"
import script from "./PreQuestion2.vue?vue&type=script&lang=js&"
export * from "./PreQuestion2.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion2.vue?vue&type=style&index=0&id=8906e37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8906e37c",
  null
  
)

export default component.exports